import { useParams } from 'react-router-dom'

import useSWR from 'swr'

import { getAccountExplain } from 'api'
import { AccountActivity } from 'modules/accountActivity/domain'

export const useAccountAccountExplain = () => {
  const { id: accountId } = useParams<{ id: string }>()

  const { data, error } = useSWR<AccountActivity, Error>(
    accountId && `accountExplain-${accountId}`,
    async () => {
      const { data } = await getAccountExplain({ accountId })
      return data
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  return { data, error }
}
